var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
export var Styled = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .username {\n    font-weight: bold;\n  }\n"], ["\n  .username {\n    font-weight: bold;\n  }\n"])));
var templateObject_1;
//# sourceMappingURL=style.js.map